export { default } from './LabelWithAsterisks';
